import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import TestTemplatesContainer from "@/screens/ManageProducts/components/TestTemplates/components/TestTemplatesContainer"
import { testTemplateSearchParamsSchema } from "@/screens/ManageProducts/components/TestTemplates/types"

export const Route = createFileRoute("/app/admin/manage-products/_layout/test-templates")({
  validateSearch: testTemplateSearchParamsSchema,
  search: {
    middlewares: [retainSearchParams(testTemplateSearchParamsSchema.keyof().options)],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.TEST_TEMPLATE_VIEW]}>
      <TestTemplatesContainer />
    </PermissionContentWrapper>
  ),
})
